import { GoogleMap, GoogleMapProps } from '@react-google-maps/api';
import React, { ReactNode } from 'react';
import { defaultCoordinates } from 'src/constants/map';
import './style.scss';

interface Props extends GoogleMapProps {
  mapRef?: React.RefObject<GoogleMap> | null;
  children?: ReactNode;
}

class MapWrapper extends React.Component<Props> {
  render() {
    const { mapRef, ...props } = this.props;

    return (
      <>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <GoogleMap {...props} mapContainerStyle={{ display: 'flex', flex: 1 }} zoom={5} center={defaultCoordinates} ref={mapRef}>
          {this.props.children}
        </GoogleMap>
      </>
    );
  }
}

export default MapWrapper;
